import { gql } from '@apollo/client';

export const FeeSummaryFragment = gql`
    fragment FeeSummaryFragment on CartPrices {
        applied_fees {
            amount {
                currency
                value
            }
            label
        }
    }
`;

import React from 'react';
export default function Stub() { return null; }
